import {useEffect} from 'react';

const useHelmet = (title: string): void => {
  useEffect(() => {
    document.title = title;
  }, [title]);
};

export default useHelmet;
